const BankAccountsList = require("../components/BankAccountsList");
const StablecoinAccountsList = require("../components/StablecoinAccountsList");
const BankAccountForm = require("../components/BankAccountForm").default;
const StablecoinAccountForm = require("../components/StablecoinAccountForm").default;

module.exports = [
  {
    id: 'bankAccounts',
    title: 'Bank Accounts',
    listComponent: BankAccountsList,
    formComponent: BankAccountForm
  },
  {
    id: 'stablecoinAccounts',
    title: 'Stablecoin Accounts',
    listComponent: StablecoinAccountsList,
    formComponent: StablecoinAccountForm
  }
]
